/** Mission Control / mission detail task thread (chat) panel chrome. */
export const TASK_THREAD_SHELL_CLASS =
  "bg-white border border-slate-200 shadow-sm dark:border-transparent dark:bg-slate-700 dark:shadow-none";

export const TASK_THREAD_FRAME_DRAWER_CLASS =
  "bg-white/95 dark:bg-slate-900/40";

export const TASK_THREAD_TITLE_CLASS =
  "text-sm font-medium leading-snug text-slate-900 dark:text-slate-100 py-0.5";

export const TASK_THREAD_LABEL_CLASS =
  "text-[10px] font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400";

export const TASK_THREAD_META_CLASS = "text-xs text-slate-500 dark:text-slate-400";

export const TASK_THREAD_META_EMPHASIS_CLASS =
  "text-slate-700 dark:text-slate-300";

export const TASK_THREAD_SUMMARY_CLASS =
  "text-xs leading-snug text-slate-600 dark:text-slate-300";

export const TASK_THREAD_USER_BUBBLE_CLASS =
  "rounded-xl px-3 py-2.5 text-sm max-w-[80%] bg-slate-200 text-slate-900 dark:bg-slate-700/60 dark:text-slate-100";

export const TASK_THREAD_AGENT_BUBBLE_CLASS =
  "rounded-xl px-3 py-2.5 text-sm min-w-0 w-full max-w-full overflow-hidden bg-indigo-50 text-slate-800 dark:bg-indigo-500/[0.08] dark:text-slate-200";

export const TASK_THREAD_COMPOSE_INPUT_CLASS =
  "border border-slate-200 bg-slate-50 dark:border-transparent dark:bg-slate-800/90";

export const TASK_THREAD_ACTION_NEUTRAL_CLASS =
  "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800/60 dark:text-slate-300 dark:hover:bg-slate-700/60";

export const TASK_THREAD_ACTION_PRIMARY_CLASS =
  "bg-green-100 text-green-800 hover:bg-green-200 dark:bg-green-500/15 dark:text-green-200 dark:hover:bg-green-500/25";

export const TASK_THREAD_ACTION_DESTRUCTIVE_CLASS =
  "bg-red-100 text-red-800 hover:bg-red-200 dark:bg-red-500/15 dark:text-red-200 dark:hover:bg-red-500/25";

export const TASK_THREAD_ACTION_SECONDARY_CLASS =
  "bg-indigo-100 text-indigo-800 hover:bg-indigo-200 dark:bg-indigo-500/15 dark:text-indigo-200 dark:hover:bg-indigo-500/25";

export const TASK_THREAD_ACTION_SNOOZE_ACTIVE_CLASS =
  "bg-indigo-100 text-indigo-900 dark:bg-indigo-500/25 dark:text-indigo-100";

export const TASK_THREAD_FIELD_CLASS =
  "w-full rounded-lg bg-white px-2.5 py-1.5 text-xs text-slate-900 placeholder:text-slate-400 resize-none focus:outline-none focus:ring-1 dark:bg-slate-900/50 dark:text-slate-200 dark:placeholder:text-slate-600";

export const TASK_THREAD_BANNER_CLASS =
  "border-b border-slate-200 bg-slate-100 px-4 py-3 dark:border-white/5 dark:bg-slate-500/[0.08]";

export const TASK_THREAD_BANNER_CODE_CLASS =
  "mt-1 block rounded bg-slate-200 px-2 py-1 leading-relaxed break-all text-slate-700 dark:bg-slate-900/40 dark:text-slate-300";
